import React, { useState, useEffect } from 'react';
import { Container, Label, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';
import '../share/form.css';
import { Formik, Field, Form, FieldArray, ErrorMessage } from 'formik';
import CreateTableComponent from "../share/CreateTableComponent";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import * as Yup from 'yup'
import { BsPlusLg } from "react-icons/bs";
import { Loading } from '../share/loading'
import { AiOutlineDelete } from "react-icons/ai";
import TextErrors from "../share/TextErrors";
import '../share/TabStyle.css'
import "../share/form.css";
import "../share/DatePickerInputStyle.css"
import "../share/ModalReactStrapStyle.css"
import { FiEdit3 } from "react-icons/fi";
import '../share/form.css';
import Swal from 'sweetalert2';

export function CreateJobPositionFormTestComponent() {
    let rootColorErrors = "#d33";
    let rootColorPrimary = "#0A66C2";
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const user = JSON.parse(localStorage.getItem("userData"));
    const [cansubmit, setCanSubmit] = useState(false);
    const [courseSelect, setCourseSelect] = useState([]);
    // console.log("courseSelect", courseSelect)
    const [tabIndex, setTabIndex] = useState(0);
    const [detailJobPositionDataAr, setDetailJobPositionDataAr] = useState([]);
    // console.log("detailJobPositionDataAr", detailJobPositionDataAr)
    const [loading, setLoading] = useState(false);
    const [openModalForm, setOpenModalForm] = useState(false);
    const Toggle = () => setOpenModalForm(!openModalForm);

    useEffect(() => {
        ListTrainTestJobposition()
        getTestJobposition()
    }, [])


    // ฟังก์ชั่นกรณีกดย้อนกลับ
    function checkPreviousPage() {
        return navigate(`/borrowing/BorrowForm/attatchFileTest?req=${searchParams.get("req")}&train=${searchParams.get("train")}&test=${searchParams.get("test")}&status=${searchParams.get("status")}`)
    }



    useEffect(() => {
        async function checkCanSubmit() {
            let check = [];
            await courseSelect.forEach((test) => {
                test.listTestTimes.forEach((time) => {
                    time.employeeAmount === time.personAmount ? check.push(true) : check.push(false)
                })
            })

            check.every(x => x === true) ? setCanSubmit(true) : setCanSubmit(false)

        }
        checkCanSubmit()
    }, [courseSelect])
    async function getTestJobposition() {
        setLoading(true)
        let postData = new FormData();
        postData.append("borrowId", searchParams.get("req"))
        // postData.append("trainTest",1)
        try {

            let res = await fetch("/api/BorrowRegis/getTrainTestJobposition", {
                method: "POST",
                body: postData
            });
            const resJson = await res.json()
            // console.log("resJson", resJson.dataenum)
            setDetailJobPositionDataAr(resJson.dataenum.filter(item => {
                return item.testJobpositionName != null
            }));
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    async function ListTrainTestJobposition() {
        setLoading(true)
        try {
            let res = await fetch("/api/BorrowRegis/listTrainTestJobposition", {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify({
                    "BorrowId": searchParams.get("req")
                }),
            });
            const resJson = await res.json()
            // console.log('resJson',resJson.dataenum)
            setCourseSelect(resJson.dataenum.filter(item => {
                return item.testId != null
            }));
            // console.log(resJson.dataenum);
        } catch (err) {
            console.log("err =>" + err)
        } finally {
            setLoading(false)
        }
    }

    const onSubmit = async (values) => {
        let postData = new FormData();
        postData.append("borrowId", values.borrowId)
        Swal.fire({
            icon: "info",
            title: "ยืนยันการส่งคำขอกู้ยืมเงินหรือไม่?",
            text: "",
            confirmButtonColor: rootColorPrimary,
            confirmButtonText: "ยันยัน",
            cancelButtonText: 'ยกเลิก',
            cancelButtonColor: '#d33',
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await fetch("/api/BorrowRegis/confirmBorrow", {
                        method: "POST",
                        body: postData
                    });
                    let resJson = await res.json();

                    if (resJson.status === 1) {
                        setLoading(false)
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/borrowing/");
                            } else {
                                navigate("/borrowing/");
                            }
                        });
                    } else {
                        setLoading(false)
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        })

    }

    const initialValues = {
        // detailJobPositionDataAr: detailJobPositionDataAr,
        borrowId: searchParams.get("req"),
    }
    const validationSchema = Yup.object().shape({

    })
    const detailJobpositionValidationSchema = Yup.object().shape({
        testJobpositionName: Yup.string().required("กรุณากรอกชื่อตำแหน่งงาน"),
        testOccupations: Yup.array().of(
            Yup.object().shape({
                testTimes: Yup.array().of(
                    Yup.object().shape({
                        testTimeId: Yup.number(),
                        personAmount: Yup.number().when("testTimeId", {
                            is: (value) => value > 0,
                            then: Yup.number().typeError("กรุณากรอกตัวเลข").positive("จำนวนคนต้องมีจำนวนมากกว่า 0").required("กรุณากรอกจำนวนคน")
                        })
                    })
                )
            })
        )
    })


    const detailJobpositionInitialValues = {
        borrowId: searchParams.get("req"),
        registerId: user.registerId,
        id: 0,
        testJobpositionName: "",
        testOccupations: courseSelect.map((test) => ({
            testId: test.testId,
            testTimes: test.listTestTimes.map((time) => ({
                personAmount: "",
                testTimeId: 0
            }))
        }))
    }

    const detailJobpositionOnSubmit = async (values) => {
        let pass = false;
        // console.log("values", values)

        const { testOccupations } = values
        await testOccupations.forEach((test) => {
            test.testTimes.forEach((time) => {
                if (time.personAmount !== "") {
                    pass = true;
                    return;
                }
            })
        })

        if (pass) {
            Swal.fire({
                icon: "info",
                title: "ยืนยันการบันทึกข้อมูลหรือไม่?",
                text: "",
                confirmButtonColor: rootColorPrimary,
                confirmButtonText: "ยันยัน",
                cancelButtonText: 'ยกเลิก',
                cancelButtonColor: '#d33',
                showCancelButton: true,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true)
                    // console.log(values)
                    try {
                        let res = await fetch("/api/BorrowRegis/saveTestJobPosition", {
                            method: "POST",
                            headers: { "Content-type": "application/json" },
                            body: JSON.stringify(values)
                        });

                        let resJson = await res.json();

                        if (resJson.status === 1) {

                            Swal.fire({
                                icon: "success",
                                title: "บันทึกข้อมูลสำเร็จ",
                                text: "",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            }).then((result) => {
                                getTestJobposition()
                                ListTrainTestJobposition()
                                Toggle()
                                if (result.isConfirmed) {
                                    return;
                                } else {
                                    navigate("/borrowing/");
                                }
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "บันทึกข้อมูลไม่สำเร็จ",
                                text: `เนื่องจาก ${resJson.message}`,
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            });
                        }
                    } catch (e) {
                        console.log(e)
                    }
                    finally {
                        setLoading(false)
                    }
                }
            })
        } else {
            Swal.fire({
                icon: "warning",
                title: "",
                text: "กรุณาเลือกหลักสูตร / รุ่นการฝึกอบรมฯ อย่างน้อย 1 รายการ",
                confirmButtonColor: rootColorPrimary,
                confirmButtonText: "ตกลง",
            })
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ values, handleChange, setFieldValue, resetForm }) => {
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">

                                <Form className='p-5'>
                                    <Formik
                                        initialValues={detailJobpositionInitialValues}
                                        validationSchema={detailJobpositionValidationSchema}
                                        onSubmit={detailJobpositionOnSubmit}
                                        enableReinitialize

                                    >
                                        {({ values, handleChange, setFieldValue, resetForm, touched, errors }) => {
                                            // console.log("values", values)
                                            // console.log("errors", errors)

                                            async function OnEdit(row) {
                                                resetForm();
                                                // console.log("row", row)
                                                setFieldValue("id", row.id)
                                                setFieldValue("testJobpositionName", row.testJobpositionName)
                                                await courseSelect.forEach((course, i) => {
                                                    row.testOccupations.forEach((mycourse) => {
                                                        if (course.testId === mycourse.testId) {
                                                            // console.log("fdfsdf")
                                                            course.listTestTimes.forEach((classItem, index) => {
                                                                mycourse.testTimes.forEach((myClass) => {
                                                                    if (classItem.testTimeId === myClass.testTimeId) {
                                                                        // console.log("fdsfsdsdsdddddddf")
                                                                        setFieldValue(`testOccupations[${i}].testTimes[${index}].testTimeId`, myClass.testTimeId);
                                                                        setFieldValue(`testOccupations[${i}].testTimes[${index}].personAmount`, myClass.personAmount);
                                                                    }
                                                                })
                                                            })

                                                        }
                                                    })
                                                })
                                                await Toggle(!openModalForm);
                                            }

                                            async function OnDelete(id) {
                                                Swal.fire({
                                                    icon: "info",
                                                    title: "ยืนยันการลบข้อมูลหรือไม่?",
                                                    text: "",
                                                    confirmButtonColor: rootColorPrimary,
                                                    confirmButtonText: "ยันยัน",
                                                    cancelButtonText: 'ยกเลิก',
                                                    cancelButtonColor: '#d33',
                                                    showCancelButton: true,
                                                }).then(async (result) => {
                                                    if (result.isConfirmed) {
                                                        let postData = new FormData();
                                                        postData.append("id", id)
                                                        try {
                                                            let res = await fetch("/api/BorrowRegis/deleteTestJobposition", {
                                                                method: "POST",
                                                                body: postData
                                                            });
                                                            let resJson = await res.json();

                                                            if (resJson.status === 1) {
                                                                getTestJobposition()
                                                                ListTrainTestJobposition()
                                                                Swal.fire({
                                                                    icon: "success",
                                                                    title: "ลบข้อมูลสำเร็จ",
                                                                    text: "",
                                                                    confirmButtonColor: "#0A66C2",
                                                                    confirmButtonText: "ตกลง",
                                                                }).then(() => {
                                                                    window.location.reload();

                                                                });
                                                            } else {
                                                                Swal.fire({
                                                                    icon: "error",
                                                                    title: "ลบข้อมูลไม่สำเร็จ",
                                                                    text: `เนื่องจาก ${resJson.message}`,
                                                                    confirmButtonColor: "#0A66C2",
                                                                    confirmButtonText: "ตกลง",
                                                                });
                                                            }

                                                        } catch (e) {
                                                            // console.log("err", e)
                                                        }
                                                    }
                                                })

                                            }

                                            const COLUMNS = [
                                                {
                                                    Header: "ลำดับ",
                                                    accessor: (_row, i) => i + 1,
                                                },
                                                {
                                                    Header: "ชื่อตำแหน่งงาน",
                                                    accessor: "testJobpositionName",
                                                },
                                                {
                                                    Header: "จำนวนผู้เข้ารับการทดสอบฯ",
                                                    accessor: "personAmount",
                                                },
                                                {
                                                    Header: "รายละเอียด",
                                                    accessor: "id",
                                                    Cell: ({ row, value }) => {
                                                        return (
                                                            <div className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn border border-1 mx-1"
                                                                    onClick={() =>
                                                                        OnEdit(row.original)
                                                                    }
                                                                >
                                                                    <FiEdit3 style={{ color: rootColorPrimary }} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn border border-1 mx-1"
                                                                    onClick={() =>
                                                                        OnDelete(row.original.id)
                                                                    }
                                                                >
                                                                    <AiOutlineDelete style={{ color: rootColorErrors }} />
                                                                </button>
                                                            </div>
                                                        );
                                                    },
                                                },
                                            ];
                                            async function onAdd() {
                                                resetForm();
                                                Toggle()
                                            }
                                            const AddDetailCourseBtn = () => {
                                                return (
                                                    <button
                                                        type='button'
                                                        className='btn-green'
                                                        onClick={() => onAdd()}
                                                    >
                                                        <BsPlusLg className="mx-2" />
                                                        เพิ่มข้อมูลตำแหน่งของพนักงาน
                                                    </button>
                                                );
                                            };


                                            return (
                                                <>
                                                    <div
                                                        className='d-flex justify-content-between align-items-center'
                                                    >
                                                        <Label>ข้อมูลตำแหน่งของพนักงานที่เข้ารับการทดสอบฯ</Label>
                                                    </div>
                                                    <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                                        <TabList>
                                                            {courseSelect.map((test, i) => (
                                                                <Tab>สาขาอาชีพ {test.lawOccupationName}</Tab>
                                                            ))}
                                                        </TabList>

                                                        {courseSelect?.map((course, index) => (
                                                            <TabPanel>
                                                                <div className='p-3' style={{ backgroundColor: "#E0F3FF" }}>
                                                                    {course.listTestTimes.map((time) => (
                                                                        <li>
                                                                            ครั้งที่ {time.time} ผู้เข้ารับการทดสอบฯ {time.personAmount} / {time.employeeAmount}
                                                                        </li>
                                                                    ))}

                                                                </div>

                                                            </TabPanel>
                                                        ))}

                                                    </Tabs>


                                                    <div className='mt-2'>
                                                        <CreateTableComponent
                                                            column={COLUMNS}
                                                            dataInput={detailJobPositionDataAr}
                                                            FormInput={AddDetailCourseBtn}
                                                        />
                                                    </div>

                                                    <div>
                                                        <Modal
                                                            isOpen={openModalForm}
                                                            toggle={Toggle}
                                                            scrollable
                                                            backdrop={'static'}
                                                            keyboard={false}
                                                            centered
                                                            size="lg"
                                                        >
                                                            <ModalHeader toggle={Toggle} className="text-center styled-modal">
                                                                บันทึกข้อมูลตำแหน่งงาน
                                                            </ModalHeader>
                                                            <ModalBody>

                                                                <div className="w-100">
                                                                    <Form className="p-4" autoComplete="off">
                                                                        <Field
                                                                            name={`id`}
                                                                            type="text"
                                                                            disabled={true}
                                                                            style={{ display: "none" }}
                                                                        />
                                                                        <Label
                                                                            className="me-4 w-100 "
                                                                            style={{ lineHeight: "30px" }}
                                                                        >
                                                                            ชื่อตำแหน่งงาน
                                                                            <span className="require-input">*</span>
                                                                            {touched.testJobpositionName && errors.testJobpositionName ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.testJobpositionName}
                                                                                </span>
                                                                            ) : null}

                                                                        </Label>
                                                                        <Field
                                                                            name={`testJobpositionName`}
                                                                            type="text"
                                                                        >
                                                                            {({ field, meta, form }) => (
                                                                                <Input
                                                                                    type="text"
                                                                                    className={meta.touched && !form.values.testJobpositionName ? "input-error rounded-pill text-center input-color cus-type" : " cus-type rounded-pill text-center input-color"}
                                                                                    {...field}
                                                                                />
                                                                            )}
                                                                        </Field>

                                                                        <Label
                                                                            className='mt-3'>
                                                                            กรุณาเลือกสาขาอาชีพและครั้งที่ดำเนินการทดสอบฯ
                                                                            <span className="require-input">*</span>
                                                                        </Label>
                                                                        <FieldArray name={`testOccupations`}>
                                                                            {(fieldArrayProps) => {
                                                                                return (
                                                                                    <>
                                                                                        {courseSelect?.map((test, i) => (
                                                                                            <div className='mt-3 px-3' key={i}>
                                                                                                <li>สาขาอาชีพ <span style={{ color: "#0A66C2" }}>{test.lawOccupationName}</span></li>
                                                                                                {test.listTestTimes.map((time, index) => (
                                                                                                    <div key={index} >
                                                                                                        <div className='d-flex align-items-center mt-3'>
                                                                                                            <Field
                                                                                                                name={`testOccupations[${i}].testTime[${index}].testTimeId`}
                                                                                                                type="checkbox"
                                                                                                            >
                                                                                                                {({ field, meta, form }) => (
                                                                                                                    <Input
                                                                                                                        type="checkbox"
                                                                                                                        className="ms-2 cus-type m-0"
                                                                                                                        {...field}
                                                                                                                        onChange={(e) => {
                                                                                                                            handleChange(e)
                                                                                                                            if (e.target.checked) {
                                                                                                                                setFieldValue(`testOccupations[${i}].testTimes[${index}].testTimeId`, time.testTimeId);
                                                                                                                            } else {
                                                                                                                                setFieldValue(`testOccupations[${i}].testTimes[${index}].testTimeId`, 0);
                                                                                                                                setFieldValue(`testOccupations[${i}].testTimes[${index}].personAmount`, "");
                                                                                                                            }

                                                                                                                        }}
                                                                                                                        checked={values.testOccupations[i].testTimes[index].testTimeId !== 0 ? true : false}
                                                                                                                    />
                                                                                                                )}
                                                                                                            </Field>
                                                                                                            <span className='ms-2'>
                                                                                                                ครั้งที่ <span style={{ color: "#0A66C2" }}>{time.time}</span>
                                                                                                            </span>

                                                                                                            <span className='ms-2'>
                                                                                                                จำนวนผู้เข้ารับการทดสอบฯ
                                                                                                            </span>

                                                                                                            <Field
                                                                                                                name={`testOccupations[${i}].testTimes[${index}].personAmount`}
                                                                                                                type="text"
                                                                                                            >
                                                                                                                {({ field, meta, form }) => (
                                                                                                                    <Input
                                                                                                                        type="text"
                                                                                                                        className="cus-type rounded-pill input-color w-25 ms-3 text-center"
                                                                                                                        disabled={values.testOccupations[i].testTimes[index].testTimeId === 0 ? true : false}
                                                                                                                        {...field}
                                                                                                                    />
                                                                                                                )}
                                                                                                            </Field>
                                                                                                            <span className='ms-2'>
                                                                                                                คน
                                                                                                            </span>
                                                                                                            <ErrorMessage name={`testOccupations[${i}].testTimes[${index}].personAmount`} component={TextErrors} />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        ))}
                                                                                    </>
                                                                                )
                                                                            }}
                                                                        </FieldArray>
                                                                        <hr />
                                                                        <div className='d-flex justify-content-center align-items-center'>
                                                                            <button className='btn-blue w-25' type="submit">บันทึก</button>
                                                                        </div>
                                                                    </Form>
                                                                </div>
                                                            </ModalBody>


                                                        </Modal>

                                                    </div>


                                                </>
                                            )
                                        }}


                                    </Formik>

                                    <div className='d-flex justify-content-between align-items-center mt-5'>

                                        <button
                                            onClick={checkPreviousPage}
                                            type="button"
                                            className='btn-blue px-4 w-25'
                                        >
                                            ย้อนกลับ
                                        </button>
                                        <button
                                            type="submit"
                                            className='btn-blue px-4 w-25'
                                            disabled={!cansubmit}
                                        >
                                            ส่งคำขอ
                                        </button>



                                    </div>

                                </Form>


                            </div>

                        ) : (
                            <Loading />
                        )

                        }

                    </Container>


                )

            }}
        </Formik>
    );
}

